import React from 'react';
import { Row, Col } from 'react-bootstrap';
import iconCalendar from '../../../assets/images/icons/calendar-3.svg';
import iconPlace from '../../../assets/images/icons/placeholder.svg';
import iconTime from '../../../assets/images/icons/time.svg';

let httpUrl;
let aEnable;
let target;

const Events = (props) => (
  <Row style={{maxWidth: '1023px',}} className="events-section">
    <Col className="events-wrapper" sm={12}>
      <div className="title-events-wrapper">
        <h2 className="title-events">
          <img src={iconCalendar} className="calendar-blue" alt=""/>
          Upcoming Events
        </h2>
      </div>
      <Row className="events-body">
        {Object.keys(props.feed).map((key) => (
          <Col className="event-wrapper" key={`event-${key}`} sm={6}>

            <div className="event-summary-wrapper">
              <ul
                style={{
                  listStyle: 'none',
                  marginLeft: '15px',
                }}
              >
              {Object.keys(props.feed[key]).map((key2, index) => {
                aEnable = (props.feed[key][key2].url !== '' &&  props.feed[key][key2].url !== ' ') ? 'all' : 'none' ;
                target = (props.feed[key][key2].url !== '' &&  props.feed[key][key2].url !== ' ')? `"_blank"` :``;
                httpUrl = (props.feed[key][key2].url.includes('http') && props.feed[key][key2].url!==` `) ? props.feed[key][key2].url : `#`;
                
                return (
                  <li key={`feed-${index}`}>
                    <div className="event-date-wrapper">
                      <h3 className="event-date">{key}</h3>
                    </div>
                    <div>
                      <a
                        target = {target}
                        href={httpUrl}
                        rel="noopener noreferrer" 
                        style={{pointerEvents: aEnable, display:"block"}}
                      >
                        {props.feed[key][key2].title}
                      </a>
                      {props.feed[key][key2].location !== '' && <div
                        style={{
                          paddingTop: '10px',
                          textIndent: '-15px',
                          paddingLeft: '15px',
                        }}
                      >
                        <img
                          style={{
                            marginRight: '5px',
                          }}
                          src={iconPlace}
                          alt=""
                        />
                        {props.feed[key][key2].location}
                      </div>}
                      {(props.feed[key][key2].start_time !== '' && props.feed[key][key2].start_time !== '00:00:00')
                        && <div
                        style={{
                          paddingTop: '5px',
                        }}
                      >
                        <img
                          style={{
                            marginRight: '5px',
                          }}
                          src={iconTime}
                          alt=""
                        />
                        {props.feed[key][key2].start_time}
                      </div>}
                    </div>
                  </li>
              )})}
              </ul>
            </div>
          </Col>
        ))}
      </Row>
    </Col>
    <div className="all-news-wrapper">
        <a
          className="all-news"
          target="_blank"
          rel="noopener noreferrer"
          href="https://calendar.fiu.edu/"
        >
          View all Events
        </a>
    </div>
  </Row>
)

export default Events;



// WEBPACK FOOTER //
// ./src/app/screens/landing/events.js